import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calcDriverPayoutSheet',
  standalone: true,
})
export class CalcDriverPayoutSheetPipe implements PipeTransform {
  transform(item: {
    DriverDefaultWithholdPercentage: number | null;
    IsInternalOrg: boolean;
    SuggestedADROITContractorsPayoutPercentageJSON: { [key: string]: number };
    OrgID: string;
    PayoutsAdjustments: number;
    ContractorOriginalPayout: number;
    SuggestedServiceProviderContractorsPayoutPercentageJSON: {
      [key: string]: number;
    };
  }): string | number {
    // Early return for null or zero withhold percentage
    if (item.DriverDefaultWithholdPercentage === null || item.DriverDefaultWithholdPercentage === 0) {
      return 0;
    }

    const totalAmount = item.PayoutsAdjustments + item.ContractorOriginalPayout;

    // Handle standard withhold percentage case
    if (item.DriverDefaultWithholdPercentage !== 100) {
      return totalAmount * ((100 - item.DriverDefaultWithholdPercentage) / 100);
    }

    // Handle 100% withhold with organization percentage
    return this.calculateWithOrganizationPercentage(item, totalAmount);
  }

  private calculateWithOrganizationPercentage(
    item: {
      IsInternalOrg: boolean;
      SuggestedADROITContractorsPayoutPercentageJSON: { [key: string]: number };
      SuggestedServiceProviderContractorsPayoutPercentageJSON: { [key: string]: number };
      OrgID: string;
    },
    totalAmount: number,
  ): number {
    const percentageMap = item.IsInternalOrg ? item.SuggestedADROITContractorsPayoutPercentageJSON : item.SuggestedServiceProviderContractorsPayoutPercentageJSON;

    const orgPercentage = this.getOrgPercentage(percentageMap, item.OrgID);

    return totalAmount * (orgPercentage / 100);
  }

  private getOrgPercentage(percentageMap: { [key: string]: number }, orgID: string): number {
    // Use organization specific percentage if available, otherwise use default (key '0')
    return percentageMap[orgID] || percentageMap[0];
  }
}
